import React, { useState, useEffect } from "react";
import UITextInput from "../UITextInput";

/**
 * @function UILimitedCharacterInput
 * @param {STRING} placeHolder - The place holder to show when nothing has been entered
 * @param {STRING} value - The value that should be set in the field
 * @param {STRING} max - The max amount of characters that can be entered
 * @param {STRING} label - The label to show under the field for the characters
 * @param {STRING} className - A classname to be added
 * @param {FUNCTION} onChange - Function be ran when the input has been updated
 * @return {React.Compeontn}
 */
export default function UILimitedCharacterInput(props) {
    const placeholder = props.placeHolder ?? "";
    const value = props.value ?? "";
    const maxCharacters = props.max ?? "32";
    const label = props.label ?? "Printed on check";
    const className = props.className ?? "";
    const dataPoint = props.dataPoint ?? "";

    const [ state, setState ] = useState("");
    useEffect(() => setState(props.value ?? ""), [ props.value ]);
    
    const onChange = value => props.onChange instanceof Function
        ? props.onChange(value)
        : setState(value);

    return (
        <UITextInput placeHolder={ placeholder } className={ className }
        value={ value } onChange={ onChange } maxLength={ maxCharacters } dataPoint={ props.dataPoint }>
            <div className="flex-container flex-horizontal space-between align-center">
                <p>{ label }</p>
                <p><span className="character-count">{ state.length }</span>/{ maxCharacters }</p>
            </div>
        </UITextInput>
    );
}